import { create } from "zustand";

type SettingsState = {
  saveTrigger: number;
  isSaving: boolean;
  requestSave: () => void;
  setIsSaving: (isSaving: boolean) => void;
};

export const useSettingsStore = create<SettingsState>((set) => ({
  saveTrigger: 0,
  isSaving: false,
  requestSave: () => set((s) => ({ saveTrigger: s.saveTrigger + 1 })),
  setIsSaving: (isSaving) => set({ isSaving }),
}));
